import { render, staticRenderFns } from "./CustomerModalForm.vue?vue&type=template&id=6c80e37a"
import script from "./CustomerModalForm.vue?vue&type=script&lang=js"
export * from "./CustomerModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports